<template>
  <div>

    <!-- 大图 -->
    <img src="../../../public/images/go5.jpg" class="mt" />
    <!-- 业务 -->
    <div class="center_main center">
      <div class="center_item fl">
        <img src="../../../public/images/light.png" />
        <p>智慧门户</p>
      </div>
      <div class="center_item fl">
        <img src="../../../public/images/electrician.png" />
        <p>教学管理</p>
      </div>
      <div class="center_item fl">
        <img src="../../../public/images/security.png" />
        <p>智慧教学</p>
      </div>
      <div class="center_item fl">
        <img src="../../../public/images/appliances.png" />
        <p>智慧生活</p>
      </div>
      <div class="center_item fl">
        <img src="../../../public/images/healthy.png" />
        <p>智慧管理与环境</p>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 产品简介 -->
    <div class="produce center">
      <div class="produce_title">产品简介</div>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;智慧校园利用“物联网+云计算+大数据”，构造智慧化的校园学习、
        生活、环境。将教学、科研、管理与校园生活进行充分的融合，实现校园管理智能化、校园生活一体化、校园设施数字化、
        课堂教学生动化、家校沟通无缝化。
      </p>
      <div class="img">
        <img src="../../../public/images/school.png" style="width: 100%" />
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="center product_features">
      <div class="features_left fl">
        <img src="../../../public/images/setting.png" width="70px" class="fl" />
        <p class="features_text fl" style="margin-top: 0">主要功能</p>
        <div class="clear"></div>
      </div>
      <div class="features_right fl">
        <img src="../../../public/images/mainfunction.png" width="900px" height="500px" />
      </div>
      <div class="clear"></div>
    </div>
    <!-- 总体架构 -->
    <div class="center product_features">
      <div class="features_right fl" style="margin-left:0;margin-right:120px">
        <img src="../../../public/images/architecture.png" width="900px" height="500px" />
      </div>
      <div class="features_left fl">
        <img src="../../../public/images/setting.png" width="70px" class="fl" />
        <p class="features_text fl" style="margin-top: 0">总体架构</p>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>

export default {

};
</script>

<style lang="less" scoped>
.center_main {
  padding: 50px 0;
}
.center_item {
  margin-left: 30px;
  text-align: center;
}
.center_item img {
  width: 50%;
}
.center_item p {
  font-size: 22px;
}
.center_item:hover {
  color: #5696ff;
  text-decoration: none;
  background: transparent;
  outline: none;
  text-decoration: none;
  cursor: pointer;
  -webkit-transition: none;
  -moz-transition: none;
  transition: color 0.3s linear, background-color 0.3s linear,
    background-image 0.3s linear, text-decoration 0.3s linear;
  -moz-transition: color 0.3s linear, background-color 0.3s linear,
    background-image 0.3s linear, text-decoration 0.3s linear;
  -webkit-transition: color 0.3s linear, background-color 0.3s linear,
    background-image 0.3s linear, text-decoration 0.3s linear;
  -o-transition: color 0.3s linear, background-color 0.3s linear,
    background-image 0.3s linear, text-decoration 0.3s linear;
}
.product_features {
  padding: 45px 0;
}
.produce_title {
  text-align: center;
  font-size: 35px;
  margin-bottom: 30px;
}
.img {
  width: 100%;
}
.features_left {
  padding-top: 220px;
  line-height: 70px;
}
.features_text {
  font-size: 35px;
  margin-top: 20px;
}
.features_right {
  margin-left: 120px;
}
</style>